import { address as mainAddress, abi as mainAbi } from '../contract/pro/main'
import { address as customAddress, abi as customAbi } from '../contract/pro/custom'
import { network } from '../network/pro'
export default {
  env: 'pro',
  baseUrl: 'https://dapp-api.asali-genesis.com',
  isEnableEncryption: false,
  isLog: true,
  isVerifyToken: true, 
  suffix:'4cf4c22f6e6ce089937de71339f1b87d',
  main: {
    address: mainAddress,
    abi: mainAbi
  },
  custom: {
    address: customAddress,
    abi: customAbi
  },
  network
};
